import { gql } from '@apollo/client/core';

const trim = {
  TRIM: gql`
    fragment Trim on Trim {
      trimLevels {
        label
      }
      attributes {
        marketingprefix
        shortname
        brand
      }
    }
  `,
};

export default trim;
